import type { Midi } from "@midi-fantom-utils/midi-core";

/**
 * Пересчитывает `header.durationSeconds` для уже-трансформированного
 * `Midi` (с фиксированным набором треков и каналов). Используется
 * `transformMidi`, чтобы `Report.duration` не расходился с реальным
 * файлом после переразложения.
 */
export const recomputeDurationSeconds = (midi: Midi): Midi => {
  if (midi.tracks.length === 0) {
    return { ...midi, header: { ...midi.header, durationSeconds: 0 } };
  }
  let lastTick = 0;
  for (const track of midi.tracks) {
    for (const note of track.notes) {
      const end = note.ticks + note.durationTicks;
      if (end > lastTick) lastTick = end;
    }
    for (const list of track.controlChanges.values()) {
      for (const cc of list) {
        if (cc.ticks > lastTick) lastTick = cc.ticks;
      }
    }
    for (const pb of track.pitchBends) {
      if (pb.ticks > lastTick) lastTick = pb.ticks;
    }
    for (const sx of track.sysex) {
      if (sx.ticks > lastTick) lastTick = sx.ticks;
    }
  }
  const ppq = midi.header.ppq;
  const tempos = midi.header.tempos;
  const firstBpm = tempos[0]?.bpm ?? 120;
  let seconds = 0;
  let prev = 0;
  let current = firstBpm;
  for (const t of tempos) {
    if (t.ticks >= lastTick) break;
    if (t.ticks > prev) {
      seconds += ((t.ticks - prev) / ppq) * (60 / current);
      prev = t.ticks;
    }
    current = t.bpm;
  }
  if (prev < lastTick) {
    seconds += ((lastTick - prev) / ppq) * (60 / current);
  }
  return { ...midi, header: { ...midi.header, durationSeconds: seconds } };
};